import type { ConfigProviderProps } from 'antd/es/config-provider';

import { css } from 'config/emotionCss';

const bodyStyle = css`
  .ant-select {
    max-width: 100%;
    width: 100%;
  }
`;

const modalConfig: ConfigProviderProps['modal'] = {
  closable: false,
  mask: { blur: false },
  classNames: { body: bodyStyle },
};

export default modalConfig;
